import client from './client';
import type { ApiResponse, Page } from '../types';

interface CreatePageRequest {
  name: string;
  html: string;
  capture_credentials?: boolean;
  capture_passwords?: boolean;
  redirect_url?: string;
}

export const pagesApi = {
  // Go returns a bare Page[] (not { data: [...] }).
  getAll: () =>
    client.get<Page[]>('/pages/'),

  getById: (id: number) =>
    client.get<Page>(`/pages/${id}`),

  create: (data: CreatePageRequest) =>
    client.post<Page>('/pages/', data),

  // Go's PutPage requires the body's id to match the URL id.
  update: (id: number, data: Partial<CreatePageRequest>) =>
    client.put<Page>(`/pages/${id}`, { ...data, id }),

  delete: (id: number) =>
    client.delete<ApiResponse<null>>(`/pages/${id}`),

  importSite: (url: string) =>
    client.post<Page>('/import/site', { url }),
};
